<ion-row>
  <ion-col
    size="6"
    size-sm="6"
    size-md="3"
    size-lg="3"
    size-xl="2"
    *ngIf="!platform.is('capacitor')"
  >
    <ion-card class="ion-no-margin" tappable>
      <ion-card-content class="ion-no-padding ion-text-center">
        <div class="card-content">
          <label class="button-label ion-padding" tappable>
            <div class="img-container">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/OOjs_UI_icon_add.svg/2048px-OOjs_UI_icon_add.svg.png"
              />
              <input
                [disabled]="isReadOnly"
                type="file"
                style="display: none"
                (change)="onImageSelect($event)"
              />
            </div>
            <p>Add a photo</p>
          </label>
        </div>
      </ion-card-content>
    </ion-card>
  </ion-col>
  <ion-col
    size="6"
    size-sm="6"
    size-md="3"
    size-lg="3"
    size-xl="2"
    *ngFor="let photo of clientPhotos"
  >
    <smr-booking-photo-card
      [photo]="{
        id: photo.id,
        raw: false,
        name: photo.name,
        note: '',
        date: photo.date
      }"
      [clientID]="client.id"
      [content]="content"
      (viewPhoto)="onViewPhoto($event)"
      (profilePhoto)="setProfilePhoto($event)"
      (deletePhoto)="onDeletePhoto($event)"
    >
    </smr-booking-photo-card>
  </ion-col>
</ion-row>
